module.exports = __webpack_public_path__ + "static/media/dso_location.611204df.gif";